import React from 'react';
import classnames from 'classnames';

import { StoryletCard, StoryletDescription as Description, StoryletTitle as Title, } from 'components/common';
import BranchButtons from './components/BranchButtons';
import Challenges from './components/Challenges';
import PlanButtonlet from './components/PlanButtonlet';
import { IBranch, IChallenge, IQualityRequirement } from "types/storylet";

interface Props {
  branch: IBranch,
  challenges: IChallenge[],
  currencyCost: number,
  defaultCursor: boolean,
  description: string,
  disabled: boolean,
  forceClearQreqs?: boolean,
  id: number,
  image: string,
  isChoosing?: boolean,
  isGoingBack: boolean,
  isLocked: boolean,
  isWorking: boolean,
  name: string,
  onChooseBranch: () => void,
  onToggleSecondChance: (_: boolean, __: number) => void,
  playerHasMaximumActivePlans: boolean,
  qualityRequirements: IQualityRequirement[],
}

export default function BranchComponent(props: Props) {
  const {
    branch,
    challenges,
    currencyCost,
    defaultCursor,
    description,
    forceClearQreqs,
    id,
    image,
    isChoosing,
    isGoingBack,
    isLocked,
    name,
    onToggleSecondChance,
    playerHasMaximumActivePlans,
    isWorking,
  } = props;

  return (
    <div
      className={classnames(
        'media branch media--branch',
        isLocked && 'media--locked',
        currencyCost > 0 && 'media--fate-locked',
        (isGoingBack || isChoosing) && !isWorking && 'media--semi-transparent',
      )}
      data-branch-id={id}
    >
      <div className="media__left branch__left">
        <StoryletCard
          className="branch__card"
          defaultCursor={defaultCursor}
          image={image}
          name={name}
          imageWidth={78}
          imageHeight={100}
        />
      </div>
      <div
        className={classnames(
          'media__body branch__body',
          forceClearQreqs && 'branch__body--force-clear-qreqs',
        )}
      >
        <div>
          <div className="branch__plan-buttonlet">
            <PlanButtonlet
              branch={branch}
              playerHasMaximumActivePlans={playerHasMaximumActivePlans}
            />
          </div>
          <Title name={name} className="branch__title" />
          <Description text={description} />
        </div>
        {currencyCost > 0 && (
          <div>
            <strong>
              This branch costs
              {' '}
              {currencyCost}
              {' '}
              Fate to play.
            </strong>
          </div>
        )}
        <Challenges
          challenges={challenges}
          toggleSecondChance={onToggleSecondChance}
          locked={isLocked}
        />
        {/*
          If the screen is wide enough to keep qreqs to the right,
          then render them inside the body
        */}
        {!forceClearQreqs && <BranchButtons {...props} />}
      </div>
      {/*
          If we need to drop the qreqs below the body to fit on fewer lines,
          then render them here instead
      */}
      {forceClearQreqs && (
        <div className="storylet__buttons--force-clear" style={{ width: '100%' }}>
          <BranchButtons {...props} />
        </div>
      )}
    </div>
  );
}

BranchComponent.displayName = 'BranchComponent';
